import styled from 'styled-components';

export const ExpertProfileContainer = styled.div`
  width: 100%;
  padding: 35px 20px 15px 20px;
  background-color: white;
`;
